import { Component, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';

import { FrontendDirectivesModule } from '../../shared/frontend-directives.module';

import { Action } from '@proman/interfaces/object-interfaces';

import { PromanButtonComponent } from '@proman/button';

@Component({
    selector: 'pm-icon-menu',
    standalone: true,
    imports: [
      FrontendDirectivesModule,

      PromanButtonComponent,
    ],
    template: `
        <div class="IconMenuComponent" (click)="$event.stopPropagation();">
            <div class="IconMenuTrigger">
                <pro-btn icon="ellipsis-v-alt" [size]="'1x'" (onClick)="isVisible = !isVisible"></pro-btn>
                @if (isVisible) {
                    <div class="IconMenuList" (mouseleave)="isVisible = false;">
                        @for (action of actions; track action) {
                            @if (action.isVisible ? action.isVisible(data) : true) {
                                <pro-btn class="NoRadius"
                                         (click)="action.callback(data);isVisible = false;"
                                         [icon]="action.icon"
                                         [theme]="action.theme || 'primary'"
                                         [pmOverlay]="{ type: 'button', data: action.tooltip }"></pro-btn>
                                @if (!$last) { <div class="Splitter">&nbsp;</div> }
                            }
                        }
                    </div>
                }
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [`
        .IconMenuComponent {
            position: relative;
        }

        .IconMenuList {
            position:absolute;
            top:-4px;
            right:0;
            background: white;
            border-radius: 4px;
            box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
            display: flex;
            flex-direction: row;
        }

        .NoRadius {
            border: 2px solid #ffffff;
            border-radius: 2px;
        }

        .NoRadius:hover {
            border-color: #cac9c8;
        }

        .Splitter {
            height: 40px;
            width: 1px;
            background: #cac9c8;
            margin: 0 2px;
        }
    `]
})

export class IconMenuButtonComponent {
    @Input() actions: Action[];
    @Input() data: { [key: string]: unknown };
    isVisible: boolean;

    constructor(
        private cd: ChangeDetectorRef
    ) {

    }
}
